module.exports = __webpack_public_path__ + "media/images/about_us/create_job-9a9a31bf6404e74eb435d15c44b8e8ca.svg";